
export default {
  download: 'Stáhnout',
}
